import React, { useEffect, useRef, useState } from 'react';
import '../App.css';
/* const imageData = [
  { title: "Mountain Landscape", description: "Majestic peaks covered in snow during golden hour" },
  { title: "Forest Path", description: "A winding trail through ancient woodland" },
  { title: "Serene Water Mirroring", description: "Serene waters mirroring the surrounding landscape" },
  { title: "Ocean Sunset Golden Hour", description: "Golden hour over endless ocean waves" },
  { title: "Rolling Sand Dunes", description: "Rolling sand dunes under vast blue skies" },
  { title: "Starry Night", description: "Countless stars illuminating the dark sky" },
  { title: "Cascading Waterfall", description: "Cascading water through lush green forest" }
];
*/
const imageData = [
  { title: "Digital-Signage-1", description: "Street fixed LED screen display" },
  { title: "Digital-Signage-2", description: "Street portal LED screen display" },
  { title: "Digital-Signage-3", description: "Wall fixed LED screen display" },
  { title: "Digital-Signage-4", description: "Indoor Wall LED screen display" },
  { title: "Digital-Signage-5", description: "Indoor wall LED screen display weather" },
  { title: "Digital-Signage-6", description: "Mall sign LED screen display" },
  { title: "Digital-Signage-7", description: "Indoor mall and office LED display" }
];

const Home: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState<number>(3);
    const [isAnimating, setIsAnimating] = useState<boolean>(false);
    const itemsRef = useRef<NodeListOf<HTMLDivElement>>(null);
    const titleRef = useRef<HTMLHeadingElement>(null);
    const descRef = useRef<HTMLParagraphElement>(null);
    const [isPlaying, setIsPlaying] = useState<boolean>(true);
    const autoplayRef = useRef<NodeJS.Timeout | null>(null);

    const startAutoplay = () => {
        if (autoplayRef.current) clearInterval(autoplayRef.current);
        autoplayRef.current = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % imageData.length);
        }, 4000);
        setIsPlaying(true);
    };

    const stopAutoplay = () => {
        if (autoplayRef.current) {
            clearInterval(autoplayRef.current);
            autoplayRef.current = null;
        }
        setIsPlaying(false);
    };

    const toggleAutoplay = () => {
        isPlaying ? stopAutoplay() : startAutoplay();
    };

    const handleUserInteraction = () => {
        stopAutoplay();
    };


    const goToIndex = (index: number) => {
    if (isAnimating || index === currentIndex) return;
        setCurrentIndex(index);
    };

    useEffect(() => {
        if (isPlaying) {
            autoplayRef.current = setInterval(() => {
                navigate(1);
            }, 3000);
        } else {
            if (autoplayRef.current) clearInterval(autoplayRef.current);
        }

        return () => {
            if (autoplayRef.current) clearInterval(autoplayRef.current);
        };
    }, [isPlaying, currentIndex]);

    useEffect(() => {
        itemsRef.current = document.querySelectorAll('.coverflow-item');
        updateCoverflow();
    }, [currentIndex]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'ArrowLeft') {
            navigate(-1);
            handleUserInteraction();
            }
            if (e.key === 'ArrowRight') {
            navigate(1);
            handleUserInteraction();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);


    const updateCoverflow = () => {
        if (isAnimating || !itemsRef.current) return;
        setIsAnimating(true);

        itemsRef.current.forEach((item, index) => {
            let offset = index - currentIndex;
            const length = itemsRef.current!.length;

            if (offset > length / 2) offset -= length;
            else if (offset < -length / 2) offset += length;

            const absOffset = Math.abs(offset);
            const sign = Math.sign(offset);

            let translateX = offset * 220;
            let translateZ = -absOffset * 200;
            let rotateY = -sign * Math.min(absOffset * 60, 60);
            let opacity = 1 - (absOffset * 0.2);
            let scale = 1 - (absOffset * 0.1);

            if (absOffset > 3) {
                opacity = 0;
                translateX = sign * 800;
            }

            item.style.transform = `
                translateX(${translateX}px)
                translateZ(${translateZ}px)
                rotateY(${rotateY}deg)
                scale(${scale})
            `;
            item.style.opacity = `${opacity}`;
            item.style.zIndex = `${100 - absOffset}`;
            item.classList.toggle('active', index === currentIndex);
        });

        if (titleRef.current && descRef.current) {
            const currentData = imageData[currentIndex];
            titleRef.current.textContent = currentData.title;
            descRef.current.textContent = currentData.description;

            titleRef.current.style.animation = 'none';
            descRef.current.style.animation = 'none';
            setTimeout(() => {
                titleRef.current!.style.animation = 'fadeIn 0.6s forwards';
                descRef.current!.style.animation = 'fadeIn 0.6s forwards';
            }, 10);
        }

        setTimeout(() => setIsAnimating(false), 600);
  };

  const navigate = (direction: number) => {
        if (isAnimating || !itemsRef.current) return;
        const length = itemsRef.current.length;
        let newIndex = currentIndex + direction;

        if (newIndex < 0) newIndex = length - 1;
        else if (newIndex >= length) newIndex = 0;

        setCurrentIndex(newIndex);
  };

  return (
    <div>
        <section id="home" className="section">
        <div className="coverflow-wrapper">
            <div className="info">
                <h2 id="current-title">LED display</h2>
            </div>

            <div className="coverflow-container" tabIndex={0}>
                <div className="coverflow" id="coverflow">
                    {imageData.map((data, index) => (
                    <div key={index}
                        className="coverflow-item" 
                        data-index={index} 
                        onClick={
                            () => {
                            goToIndex(index);
                            handleUserInteraction();
                        }}>
                        <div className="cover image-loaded">
                            <img src={`/images/${data.title.toLowerCase().replace(/ /g, '-')}.jpg`} alt={data.title} loading="lazy" />
                        </div>
                        <div className="reflection"></div>
                    </div>
                    ))}
                </div>

                <button className="nav-button prev" onClick={() => { navigate(-1); handleUserInteraction(); }}>‹</button>
                <button className="nav-button next" onClick={() => { navigate(1); handleUserInteraction(); }}>›</button>
                <div className="dots-container">
                    {imageData.map((_, index) => (
                        <div
                            key={index}
                            className={`dot ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => {
                            goToIndex(index);
                            handleUserInteraction();
                        }}
                        />
                    ))}
                </div>

                <button className="play-pause-button" onClick={toggleAutoplay}>
                    <span className="play-icon" style={{ display: isPlaying ? 'none' : 'inline' }}>▶</span>
                    <span className="pause-icon" style={{ display: isPlaying ? 'inline' : 'none' }}>❚❚</span>
                </button>

            </div>
        </div>
        </section>
    </div>
  );
};

export default Home;
